<template>
  <div id="TranshipmentCouriers">
    <v-card>
      <v-card-title class="d-flex justify-space-between">
        <h6>Entregadores</h6>
      </v-card-title>
      <div v-if="isCouriersLoading" class="d-flex justify-center py-12">
        <v-progress-circular indeterminate color="primary" />
      </div>
      <v-card-text v-else class="d-flex justify-space-around">
        <v-list class="text-truncate">
          <template v-for="(courier, i) in couriersLists.firstColumn">
            <v-list-item :key="i">
              <v-list-item-avatar>
                <v-icon v-if="hasNoImage(courier.imageLink)"> mdi-account</v-icon>
                <v-img v-else :src="courier.imageLink"></v-img>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-subtitle>
                  {{ courier.name }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
        <v-list v-if="couriers.length !== 1" class="text-truncate">
          <template v-for="(courier, i) in couriersLists.secondColumn">
            <v-list-item :key="i">
              <v-list-item-avatar>
                <v-icon v-if="hasNoImage(courier.imageLink)"> mdi-account</v-icon>
                <v-img v-else :src="courier.imageLink"></v-img>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-subtitle>
                  {{ courier.name }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </v-card-text>

      <div v-if="couriers.length > 0" class="d-flex py-4 justify-center">
        <v-btn
          :disabled="isCouriersLoading"
          v-if="couriers.length != 0"
          color="primary"
          small
          @click="couriersView = true"
          >Ver todos {{ isCouriersLoading ? ' ' : `(${couriers.length})` }}
        </v-btn>
      </div>
    </v-card>

    <transhipment-couriers-view
      :open="couriersView"
      :couriers="couriers"
      :isLoading="isCouriersLoading"
      @closeCouriersView="couriersView = false"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import TranshipmentCouriersView from './TranshipmentCouriersView.vue';
import Base64Mixin from '@/mixins/base64.mixin';
import { baseURL } from '@/api/index';

export default {
  name: 'TranshipmentCouriers',
  components: {
    TranshipmentCouriersView
  },
  props: {
    transhipmentId: {
      default: () => null,
      type: String
    }
  },

  mixins: [Base64Mixin],

  data: () => ({
    couriersView: false,
    couriers: [],
    isCouriersLoading: true
  }),
  created() {
    this.fetchCouriers(this.transhipmentId);
  },

  computed: {
    couriersLists() {
      const listColumns = {
        firstColumn: [],
        secondColumn: []
      };

      this.couriers.length
        ? this.couriers.map((courier, i) => {
            if (i < 6) {
              if (this.isEven(i)) {
                listColumns.firstColumn = [...listColumns.firstColumn, courier];
              } else {
                listColumns.secondColumn = [...listColumns.secondColumn, courier];
              }
            }
          })
        : [];

      return listColumns;
    }
  },

  methods: {
    ...mapActions('NfeStore', ['getSrcImage']),
    ...mapActions('TranshipmentStore', ['fetchTranshipmentBetweenDeliverers']),
    async fetchCouriers(id) {
      try {
        this.isCouriersLoading = true;
        const data = await this.fetchTranshipmentBetweenDeliverers(id);
        this.couriers = data;

        let couriersImage = [];
        for (let courier of this.couriers) {
          const downloadLink = await this.getCourierImg(baseURL + courier.linkDownload);
          const dataFile = await this.toBase64(downloadLink);

          couriersImage = [...couriersImage, dataFile];
        }
        this.couriers = this.couriers.map((courier, i) => {
          return { ...courier, imageLink: couriersImage[i] };
        });
      } catch (err) {
        console.error(err);
      } finally {
        this.isCouriersLoading = false;
      }
    },

    async getCourierImg(endpoint) {
      try {
        const data = await this.getSrcImage(endpoint);

        return data;
      } catch (e) {
        console.error(e);
        this.errorsType = 'error';
        this.errors = ['Opss, algo deu errado!'];
      }
    },

    hasNoImage(imageLink) {
      return imageLink.includes('problem') ? true : false;
    },

    isEven(index) {
      return index % 2 === 0 ? true : false;
    }
  }
};
</script>

<style lang="scss" scoped>
.truncates {
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
